import ActionableMessageCardStrings from '../store/schema/ActionableMessageCardStrings';
import {
    IValidationError,
    Input,
    ValidationResults,
    ValidationError,
    setProperty,
    getBoolValue,
    getStringValue,
} from 'adaptivecards';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

export default class CustomToggleInput extends Input {
    private checkboxElement: HTMLDivElement;
    private checked: boolean = false;

    public static strings: ActionableMessageCardStrings;

    public valueOn: string = 'true';
    public valueOff: string = 'false';
    public wrap: boolean = false;
    public isRequired: boolean = false;

    private onCheckboxChanged = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        this.checked = checked;
    };

    protected internalRender(): HTMLElement {
        this.checkboxElement = document.createElement('div');
        ReactDOM.render(
            <React.StrictMode>
                <Checkbox
                    defaultChecked={this.checked}
                    onChange={this.onCheckboxChanged}
                    label={this.title}
                />
            </React.StrictMode>,
            this.checkboxElement
        );

        return this.checkboxElement;
    }

    public toJSON(): any {
        let result = super.toJSON();
        setProperty(result, 'valueOn', this.valueOn, 'true');
        setProperty(result, 'valueOff', this.valueOff, 'false');
        setProperty(result, 'wrap', this.wrap);
        setProperty(result, 'isRequired', this.isRequired, false);
        return result;
    }

    public parse(json: any, errors?: Array<IValidationError>) {
        super.parse(json, errors);

        this.title = getStringValue(json['title']);
        this.checked = getBoolValue(json['value'], this.checked);
        this.valueOn = getStringValue(json['valueOn'], this.valueOn);
        this.valueOff = getStringValue(json['valueOff'], this.valueOff);
        this.wrap = getBoolValue(json['wrap'], this.wrap);
        this.isRequired = getBoolValue(json['isRequired'], this.isRequired);
    }

    public remove(): boolean {
        if (this.checkboxElement) {
            ReactDOM.unmountComponentAtNode(this.checkboxElement);
            this.checkboxElement = null;
        }

        return super.remove();
    }

    public internalValidateProperties(context: ValidationResults) {
        if (this.isRequired && !this.checked) {
            context.addFailure(this, {
                error: ValidationError.InvalidPropertyValue,
                message: CustomToggleInput.strings.warning.missingRequiredInput,
            });
        }
        return [];
    }

    public getJsonTypeName(): string {
        return 'Input.Toggle';
    }

    get value(): string {
        return this.checked ? this.valueOn : this.valueOff;
    }
}
